import {
  filledByType,
  ImmutableChat,
  ITemplateFormData,
} from "@home-health-notify/domain";
import { Box } from "@mui/material";
import { useTranslation } from "hhn-commons";
import { TemplateFormTitle, TemplateFormWrapper } from "./Template.style";
import TemplateForm from "./TemplateForm";

interface TemplatePanelProps {
  templateInfo: any;
  handleFormSubmit: (data: ITemplateFormData) => void;
  isFormSubmitting: boolean;
  chat: ImmutableChat;
  selectedRole?: filledByType;
}

const TemplatePanel = ({
  templateInfo,
  isFormSubmitting,
  handleFormSubmit,
  chat,
  selectedRole,
}: TemplatePanelProps) => {
  const { t } = useTranslation();
  const tns = (key: any) => t(key, { ns: "chat" });
  return (
    <TemplateFormWrapper>
      {templateInfo?.label && (
        <TemplateFormTitle variant="h6" data-testid="template-title">
          {templateInfo?.label}
        </TemplateFormTitle>
      )}
      {templateInfo?.form && (
        <TemplateForm
          key={templateInfo.label}
          template={templateInfo.form}
          onSubmit={handleFormSubmit}
          isFormSubmitting={isFormSubmitting}
          chat={chat}
          selectedRole={selectedRole}
        />
      )}
      {!templateInfo?.form && <Box>{tns("templates.noForm")}</Box>}
    </TemplateFormWrapper>
  );
};

export default TemplatePanel;
